import React from 'react'

import { ReactComponent as FileIcon } from '../../../../images/icons/file_icon.svg'
import { ActionDownload } from '@demandlocal/components'
import { useDownloadAgencyReport } from '../../../../api/agencies/useDownloadAgencyReport'
import toast from 'react-hot-toast'
import { useParams } from 'react-router'
import { motion } from 'framer-motion'
import { ReportsPathElement } from './AgencyReportPath'

export default function AgencyReportFiles({
  data,
}: {
  data?: Array<ReportsPathElement>
}) {
  const buttonsDisabled = false
  const { agency_id } = useParams()
  const { mutateAsync } = useDownloadAgencyReport()

  const downloadReport = async (fileName: string, agency_id: string, path: string) => {
    const toastId = toast.loading('Downloading...')
    try {
      await mutateAsync(
        {
          data: {
            agency_id: agency_id,
            path: path,
          },
        },
        {
          onSuccess: async (data) => {
            const blob = await data.blob()
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = fileName
            document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click()
            a.remove()
          },
        },
      )
      toast.success('Done downloading!', {
        id: toastId,
      })
    } catch (e) {
      toast.error('Error downloading report!', {
        id: toastId,
      })
    }
  }

  return (
    <motion.div
      layout={'size'}
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}>
      {data?.map((el) => {
        return (
          <motion.div
            layout={true}
            key={el.path}
            className={'pl-8 pt-2 flex text-xs items-center gap-2 flex-1 w-full'}>
            <div className={'w-full flex items-center justify-between px-2 gap-2'}>
              <div className={'flex items-center'}>
                <FileIcon />
                {el.name}
              </div>
              <ActionDownload
                // @ts-ignore
                className={` ${
                  buttonsDisabled
                    ? 'fill-web-gray cursor-not-allowed'
                    : 'fill-primary-persian-blue  cursor-pointer'
                }`}
                onClick={(e: Event): void => {
                  downloadReport(el.name!, agency_id!, el.path)
                  e.preventDefault()
                  e.stopPropagation()
                }}
              />
            </div>
          </motion.div>
        )
      })}
    </motion.div>
  )
}
